/** @format */
import { Context, createContext } from 'react';

import { PromoCode } from '@toucan/client/global/application';

// eslint-disable-next-line boundaries/element-types -- // eslint-disable-next-line boundaries/element-types -- I think this should be allowed, needs a discussion and re-visit
import { QuoteItemRepeaterValue } from '@toucan/client/core/quote';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface SellFormErrors {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    sellingItems?: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    buyingItems?: any[];
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface SellFormType {
    sellValues: QuoteItemRepeaterValue[];
    buyValues: QuoteItemRepeaterValue[];
    formErrors: SellFormErrors;
    hasInitialised: boolean;
    scrollToBuyIndex: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface SellFormContextProps {
    sellForm: SellFormType;
    /**
     * Promo code for quote summary / booking in
     */
    promoCode?: PromoCode;
    skuBlacklist: string[];
    setPromoCode: (promoCode?: PromoCode) => void;
    setSellValues: (sellValues: QuoteItemRepeaterValue[]) => void;
    setBuyValues: (
        buyValues: QuoteItemRepeaterValue[],
        callback?: () => void
    ) => void;
    setScrollToBuyIndex: (index: number) => void;
    setFormErrors: (formErrors: SellFormErrors) => void;
    clearSellFormData: () => void;
}

export const SellFormContext: Context<SellFormContextProps> = createContext(
    {} as SellFormContextProps
);

SellFormContext.displayName = 'SellFormContext';
